import { provideDiTokenValue } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { providePwaService } from '@bcf-vanilla-ui-ts-v1/shared/pwa/pwa.service';
import { ImportedElement } from '@bcf2-shared-pkg-v1/ui/shared/classes/bcf-lit-element';
import { provideAppMaintenanceService } from '@bcf2-v1-ui-shared/app-maintenance/app-maintenance.service';
import { provideAppAffiliateDataCatcherService } from '@bcf2-v1-ui-shared/services/app-affiliates-data-catcher.service';
import { appTsCssVars } from '@bcfds-design-system/css/tikal-casino/mobile/variables.ts-css-var';
import { setTsCssVar } from '@bcfds-design-system/ts-css-var/ts-css-var';
import { isBrowserRenderMode } from '@bcflit-constants/render-mode';
import { appStyles, appVariables } from '@bcflit-css/tikal-casino/mobile/app.styles';
import { ENV_COMMON } from '@bcflit-env/env-token';
import { provideUserPanelAuthGuardService } from '@bcflit-v1-ui-shared/services/user-panel-auth-guard.service';
import { BcfLitRouter } from '@tmf-shared-platform/router/internal';
import {
  provideRouterNavigatorService,
  RouterNavigatorService
} from '@tmf-shared-platform/router/router-navigator.service';
import { maintenanceRoutePath } from '@tmf-ui-routes/paths/maintenance.route-path';
import { CSSResult, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { BcflitBaseAppWithInstrumentations } from '../../../../bcflit-base-app-with-instrumentations';
import { appRoutes } from './app-routes';

export class AppElement extends BcflitBaseAppWithInstrumentations {
  public static override elementSelector: string = 'bcflit-app';
  public static override styles: CSSResult[] = [appVariables, appStyles];
  public override get _importedElements(): ImportedElement[] {
    return [];
  }

  @property({ attribute: false })
  public override router: BcfLitRouter = new BcfLitRouter(this, appRoutes(provideDiTokenValue(ENV_COMMON).langs));

  constructor(private _routerNavigator: RouterNavigatorService = provideRouterNavigatorService()) {
    super();
    setTsCssVar(appTsCssVars);
  }

  public override connectedCallback(): void {
    super.connectedCallback();
    providePwaService().init();
    this._sub = provideAppMaintenanceService(this)
      .doRedirectToMaintenance()
      .subscribe(() => this._routerNavigator.navigateTo(maintenanceRoutePath()));
    provideUserPanelAuthGuardService(this).init();
    provideAppAffiliateDataCatcherService().init();

    if (isBrowserRenderMode) {
      // eslint-disable-next-line @typescript-eslint/typedef
      import('@bcf2-v1-ui-shared/services/home-or-intro-preventer.service').then((mod) =>
        mod.provideHomeOrIntroPreventerService().checkAndPrevent()
      );
    }
  }

  public override render(): TemplateResult {
    return html` ${this.router.outlet()}`;
  }
}
